export const GET_ORG_INTEGRATIONS_QUERY = 'integrationData';
